import { render, staticRenderFns } from "./search-text-input.vue?vue&type=template&id=1cfba331&lang=pug&"
import script from "./search-text-input.vue?vue&type=script&lang=ts&"
export * from "./search-text-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports